import React from 'react';
import Modal from 'react-bootstrap/Modal';

// Services & Helpers
import API from 'API';
import FormHelper from 'helpers/FormHelper';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import SuperTable from 'components/common/SuperTable';

//-----------------------------------------------------------------

class RebookEmailSMSModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.form = new FormHelper({
            fields: {
                customEmailText: {
                    label: 'Custom Email Text',
                    type: 'expanding-text',
                    rows: 1
                }
            },
            getValue: (fieldName) => this.state.options[fieldName],
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.isChanged = false;
            this.setState({
                isOpen: true,
                isLoading: true,
                month: opt.month,
                options: {
                    customEmailText: ''
                }
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const { month } = this.state;
        this.setState({ isLoading: true });
        const recipients = await API.call(`rebook/list-email-sms-recipients/${month}`);
        recipients.forEach(r => {
            r.sendEmail = !r.noEmailReason;
            r.sendSMS = !r.noSMSReason
        });
        this.setState({
            recipients,
            isLoading: false
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async send() {
        //const { customerID, propertyID, options, selectedYear } = this.state;
        //this.setState({ isLoading: true });
        //await API.call('rebook/save-for-options', {
        //    propertyID,
        //    customerID,
        //    rebookMonths: options.rebookMonths,
        //    year: selectedYear
        //});
        //this.setState({ isLoading: false });
        //this.close();
        //if (this.onSave) {
        //    this.onSave();
        //}
    }

    updateFields(fields) {
        const options = { ...this.state.options };
        for (let fieldName in fields) {
            const oldValue = options[fieldName];
            const value = fields[fieldName];
            if (value != oldValue) {
                options[fieldName] = value;
            }
        }
        this.setState({ options });
    }

    updateRecipientFields(id, fields) {
        const recipients = [...this.state.recipients];
        const index = recipients.findIndex(r => r.id == id);
        const recipient = { ...recipients[index] };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            recipient[fieldName] = value;
        }
        recipients[index] = recipient;
        this.setState({ recipients });
    }

    confirmSend() {
        let msg = 'Are you sure? (may take a while, please be patient!)';
        if (this.state.recipients.some(r => r.sendSMS)) {
            msg += '\r\n\r\n';
            msg += 'NOTE: You will be charged for outgoing SMS. Please confirm that you are happy with this.';
        }
        const confirm = window.confirm(msg);
        if (confirm) {
            this.send();
        }
    }

    async send() {
        this.setState({ isLoading: true });
        const { month, options, recipients } = this.state;
        const { numEmailsSent, numEmailsFailed, numSMSSent, numSMSFailed } = await API.call('rebook/send-email-sms', {
            customEmailText: options.customEmailText,
            month,
            recipients
        });
        const msgParts = ['Summary:'];
        if (numEmailsSent > 0 || numEmailsFailed > 0) {
            msgParts.push(`${numEmailsSent} email(s) sent, ${numEmailsFailed} failed`);
        }
        if (numSMSSent > 0 || numSMSFailed > 0) {
            msgParts.push(`${numSMSSent} email(s) sent, ${numSMSFailed} failed`);
        }
        if (numEmailsSent == 0 && numEmailsFailed == 0 && numSMSSent == 0 && numSMSFailed == 0) {
            msgParts('Nothing sent or failed (?!)');
        }
        window.alert(msgParts.join('\r\n'));
        this.close();
        this.resolve();
    }

    setSendAllEmail(enable) {
        const recipients = [...this.state.recipients];
        recipients.forEach(r => {
            if (!r.noEmailReason) {
                r.sendEmail = enable;
            }
        });
        this.setState({ recipients });
    }

    setSendAllSMS(enable) {
        const recipients = [...this.state.recipients];
        recipients.forEach(r => {
            if (!r.noSMSReason) {
                r.sendSMS = enable;
            }
        });
        this.setState({ recipients });
    }

    render() {
        const {
            isOpen,
            isLoading,
            options
        } = this.state;

        if (!isOpen) {
            return null;
        }
        
        return (
            <Modal show onHide={() => this.close()} className="rebook-email-sms-modal" backdrop="static" keyboard={false}>
                {isLoading ?
                    <Modal.Body><Loader /></Modal.Body> :
                    <>
                        <Modal.Body>

                            {this.renderInner()}

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-primary" onClick={() => this.confirmSend()}>
                                Send
                            </button>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        );
    }

    renderInner() {
        const { recipients, options } = this.state;
        let numEmailSelected = 0, numSMSSelected = 0;
        let numEmailAvailable = 0, numSMSAvailable = 0;
        recipients.forEach(r => {
            if (!r.noEmailReason) {
                numEmailAvailable++;
                if (r.sendEmail) {
                    numEmailSelected++;
                }
            }
            if (!r.noSMSReason) {
                numSMSAvailable++;
                if (r.sendSMS) {
                    numSMSSelected++;
                }
            }
        });

        const cols = {
            customerName: {
                label: 'Customer',
                getValue: (colInfo, rebook) => {
                    const lines = [
                        TextHelpers.formatName(
                            rebook.customer.lastName ? rebook.customer.lastName + ', ' : '',
                            rebook.customer.title,
                            rebook.customer.firstName
                        ),
                        rebook.customer.companyName ? 'Company: ' + rebook.customer.companyName : ''
                    ];
                    return lines.filter(l => !!l).map((l, index) =>
                        <div key={index}>
                            <div>{l}</div>
                            <div>Properties: {rebook.customerPropertiesCount}</div>
                        </div>
                    );
                }
            },
            propertyName: {
                label: 'Property',
                getValue: (colInfo, rebook) => {
                    const lines = [
                        rebook.property.address.line1,
                        [
                            rebook.property.address.line2,
                            rebook.property.address.town,
                            rebook.property.address.postcode
                        ].filter(l => !!l).join(', ')
                    ];
                    return (
                        <div>
                            <div className="num-chimneys" title={`${rebook.property.numChimneys} chimney(s)`}>
                                <span className="fa-solid fa-house-chimney" />{' '}
                                {rebook.property.numChimneys}
                            </div>
                            {lines.filter(l => !!l).map((l, index) =>
                                <div key={index} style={{ width: 'auto' }}>
                                    {l}
                                </div>
                            )}
                        </div>
                    );
                }
            }
        };

        cols.sendEmail = {
            label: 'Email',
            className: 'send-comm-modal',
            getValue: (colInfo, rebook) => <>
                {!!rebook.customer.emailAddress &&
                    <span className="comm-detail">
                        {rebook.customer.emailAddress}
                    </span>
                }
                {rebook.noEmailReason ?
                    <span className="no-comm-reason">
                        {rebook.noEmailReason}
                    </span> :
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={rebook.sendEmail || false}
                            onChange={e => this.updateRecipientFields(rebook.id, { sendEmail: e.target.checked })}
                        />{' '}
                        Send
                    </label>
                }
            </>,
            renderHeaderCell: (colInfo) =>
                <th>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        Email
                        <input
                            type="checkbox"
                            className="ms-2"
                            style={{ width: 16, height: 16 }}
                            checked={numEmailSelected >= numEmailAvailable}
                            disabled={numEmailAvailable == 0}
                            onChange={e => this.setSendAllEmail(e.target.checked)}
                        />
                    </div>
                </th>
        };

        cols.sendSMS = {
            label: 'SMS',
            className: 'send-comm-modal',
            getValue: (colInfo, rebook) => <>
                {!!rebook.customer.mobileTel &&
                    <span className="comm-detail">
                        {rebook.customer.mobileTel}
                    </span>
                }
                {rebook.noSMSReason ?
                    <span className="no-comm-reason">
                        {rebook.noSMSReason}
                    </span> :
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={rebook.sendSMS || false}
                            onChange={e => this.updateRecipientFields(rebook.id, { sendSMS: e.target.checked })}
                        />{' '}
                        Send
                    </label>
                }
            </>,
            renderHeaderCell: (colInfo) =>
                <th>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        SMS
                        <input
                            type="checkbox"
                            className="ms-2"
                            style={{ width: 16, height: 16 }}
                            checked={numSMSSelected >= numSMSAvailable}
                            disabled={numSMSAvailable == 0}
                            onChange={e => this.setSendAllSMS(e.target.checked)}
                        />
                    </div>
                </th>
        };

        return (<>
            
            {this.form.render([
                'customEmailText'
            ])}

            <SuperTable
                className="rebooks-table table table-bordered mb-0"
                rows={recipients}
                keyAccessor={rebook => rebook.id}
                cols={cols}
            />
        </>);
    }
}

export default RebookEmailSMSModal;
